module.exports = __webpack_public_path__ + "img/33.7fcc7ff7.svg";